(function () {
    const section = document.querySelector('[data-popular-section]');
    const output = section?.querySelector('[data-popular-output]');
    const candidates = Array.from(document.querySelectorAll('[data-popular-candidate]'));

    if (!section || !output || candidates.length === 0) return;

    const cardsById = new Map(
        candidates.map((card) => [card.dataset.postId, card]),
    );
    const ids = candidates
        .map((card) => card.dataset.postId)
        .filter(Boolean);

    fetch(`/api/metrics/popular?ids=${encodeURIComponent(ids.join(','))}&limit=4`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
    })
        .then((response) => {
            if (!response.ok) throw new Error('Popular posts request failed');
            return response.json();
        })
        .then((metrics) => {
            metrics.forEach((metric, index) => {
                const card = cardsById.get(metric.ghost_post_id);
                if (!card) return;
                const rank = card.querySelector('[data-popular-rank]');
                if (rank) rank.textContent = String(index + 1).padStart(2, '0');
                card.hidden = false;
                output.append(card);
            });

            if (output.children.length > 0) section.hidden = false;
            else section.remove();
        })
        .catch(() => section.remove());
})();
